import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertTriangle, ChevronDown, ChevronUp } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const SOURCE_LABEL = { history: 'z historii statusu', created_at: 'z daty utworzenia' };

const MissingRow = ({ p, onSaved }) => {
  const [day, setDay] = useState('');
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`${API_URL}/reports/completion-dates/${p.id}`, { completed_at: day });
      toast.success(`Zapisano datę zakończenia: ${p.nazwa}`);
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Błąd zapisu daty');
    } finally { setSaving(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 py-2 border-b border-[var(--crm-border)]/50" data-testid={`missing-completion-row-${p.id}`}>
      <div className="flex-1 min-w-[220px]">
        <a href={`/projects/${p.id}`} className="text-sm text-[var(--crm-text-primary)] hover:text-[#FF6B35]">{p.nazwa}</a>
        <p className="text-xs text-[var(--crm-text-muted)]">{p.klient} · {p.owner_initials} · utworzono {p.created_at} · teraz liczone {SOURCE_LABEL[p.used_source] || ''} ({p.used_date})</p>
      </div>
      <Input type="date" value={day} max={new Date().toISOString().slice(0, 10)} onChange={(e) => setDay(e.target.value)}
        className="w-44 bg-[var(--crm-bg-panel)] border-[var(--crm-border)]" data-testid={`missing-completion-date-${p.id}`} />
      <Button size="sm" onClick={save} disabled={!day || saving} className="bg-[#FF6B35] hover:bg-[#e55a2b] text-white"
        data-testid={`missing-completion-save-${p.id}`}>{saving ? 'Zapisywanie...' : 'Zapisz'}</Button>
    </div>
  );
};

export const MissingCompletionBanner = ({ onChanged }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const load = useCallback(async () => {
    try { setItems((await axios.get(`${API_URL}/reports/completion-dates/missing`)).data); } catch { setItems([]); }
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!items.length) return null;
  const onSaved = () => { load(); onChanged?.(); };
  return (
    <Card className="bg-amber-500/10 border-amber-500/40 p-4" data-testid="missing-completion-banner">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 text-left"
        data-testid="missing-completion-toggle">
        <span className="flex items-center gap-2 text-sm text-amber-600 dark:text-amber-300">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span><strong data-testid="missing-completion-count">{items.length}</strong> zakończonych zleceń nie ma daty zakończenia – do celów liczą się wg daty zastępczej. Uzupełnij daty.</span>
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-amber-500" /> : <ChevronDown className="w-4 h-4 text-amber-500" />}
      </button>
      {open && <div className="mt-3" data-testid="missing-completion-list">{items.map((p) => <MissingRow key={p.id} p={p} onSaved={onSaved} />)}</div>}
    </Card>
  );
};
